import { createFileRoute } from "@tanstack/react-router";
import { CITY_PAGES } from "@/content/localPages";
import { localPageHead } from "@/content/localPageHead";
import { LocalPageView } from "@/components/marketing/LocalPageView";

export const Route = createFileRoute("/mesa-ppc-agency")({
  head: () => localPageHead(CITY_PAGES.mesa!),
  component: MesaPage,
});

function MesaPage() {
  return <LocalPageView page={CITY_PAGES.mesa!} />;
}
